// @ts-nocheck
document.addEventListener('DOMContentLoaded', function () {
  const cache = {};

  document.addEventListener('custom:wk:wishlist:add-to-cart', addItemToCart);
  document.addEventListener('wk:wishlist:change-variant:success', loadWishlistVariantProperties);
  document.addEventListener('wk:wishlist:page-view', loadWishlistVariantProperties);

  async function addItemToCart(event) {
    const { view: viewElement } = event.detail;

    const formElement = viewElement.querySelector('form.wk-form');

    if (formElement) formElement.classList.add('wk-submitting');

    const { initializedVariantId, product } = viewElement.form;
    const { properties } = await getProperties(product.url, initializedVariantId);
    const propertyEntries = Object.entries(properties || {});
    const lineItemProperties = {};

    propertyEntries.forEach(([propertyName, propertyValue]) => (lineItemProperties[propertyName] = propertyValue));

    const cartPayload = {
      items: [
        {
          id: initializedVariantId,
          quantity: 1,
          properties: lineItemProperties,
        },
      ],
    };

    try {
      const cartResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(cartPayload),
      });

      const cartData = await cartResponse.json();

      if (!cartResponse.ok) {
        throw new Error(cartData.description || cartData.message || 'Failed to add product to cart');
      }

      window.location.href = Theme.routes.cart_url;
    } catch (error) {
      console.log(error);
    } finally {
      if (formElement) formElement.classList.remove('wk-submitting');
    }
  }

  async function getProperties(productUrl, variantId) {
    const cacheKey = `${productUrl}?variant=${variantId}`;

    if (cache[cacheKey]) {
      return cache[cacheKey];
    }

    try {
      const requestUrl = new URL(productUrl, window.location.origin);
      requestUrl.searchParams.set('variant', variantId);
      requestUrl.searchParams.set('section_id', 'api-properties');

      const responseHtml = await (await fetch(requestUrl.toString())).text();
      const parsedDocument = new DOMParser().parseFromString(responseHtml, 'text/html');
      const parsedProperties = JSON.parse(parsedDocument.querySelector('[data-api-properties]').textContent);

      cache[cacheKey] = parsedProperties;
      return parsedProperties;
    } catch (error) {
      console.log(error);
      return {
        texts: {},
        properties: {},
      };
    }
  }

  function delay(ms) {
    new Promise((resolve) => setTimeout(resolve, ms));
  }

  async function loadWishlistVariantProperties(event) {
    await delay(500);

    try {
      const {
        data: {
          wishlist: { items: wishlistItems },
          product,
          variant,
        },
      } = event.detail;
      let items = wishlistItems;

      if (product && product.url && variant && variant.id) {
        const item = [...wishlistItems].find((item) => item.product.id == product.id);
        items = [
          {
            id: item.id,
            product,
            variant,
          },
        ];
      }

      const wishlistVariants = [...items].map((wishlistItem) => {
        return {
          wishlistId: wishlistItem.id,
          productUrl: product ? product.url : wishlistItem.product.url,
          variantId: variant ? variant.id : wishlistItem.variantId,
        };
      });

      const getCollectionButtons = () => {
        return wishlistVariants.map(({ wishlistId }) =>
          document.querySelector(`button.wk-cta-button[data-wishlist-item-id="${wishlistId}"]`),
        );
      };

      const variantProperties = await Promise.all(
        wishlistVariants.map((variant) => getProperties(variant.productUrl, variant.variantId)),
      );

      const collectionButtons = getCollectionButtons();

      collectionButtons.forEach((button, index) => {
        const { texts } = variantProperties[index];

        if (texts && texts.button && button instanceof HTMLButtonElement) {
          const label = button.querySelector('.add-to-cart-text__content .wk-cta-label') || button;
          label.textContent = texts.button;
        }
      });
    } catch (error) {
      console.log(error);
    }
  }
});
